const Component = () => import('./ShopWithPoints');

export { Component };
